import { Box, Pagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getTransactions,
  getTransactionsByUserIdOrTransactionId,
} from "../../redux/actions/transactions.actions";
import { useEffect, useState } from "react";
import { FiltersTransactions } from "./filters-transactions";
import { TablePortalTransactions } from "./table-portal-transactions";
import { TableTenuiTransactions } from "./table-tenui-transactions";
import { TablePayoneerTransactions } from "./table-payoneer-transactions";
import { useGetUser } from "../../hooks/useGetUser";

export const TransactionsContainer = () => {
  const [filters, setFilters] = useState({
    transactionType: "Portal",
    transactionNumber: "",
  });

  const {
    data: transactions,
    isLoading: isLoadingTransactions,
    isError: isErrorTransactions,
    pagination: paginationTransactions,
  } = useSelector((state) => state.transactions);

  const { credentials, user } = useGetUser();

  const dispatch = useDispatch();

  function handleGetTransactions(newFilters = null, credentialId = null) {
    const baseFilters = newFilters ? newFilters : filters;
    const finalFilters = {
      ...baseFilters,
      credentialId,
    };

    if (credentialId) {
      dispatch(getTransactions(finalFilters));
    }
  }

  useEffect(() => {
    if (user?.usuarioid) {
      dispatch(
        getTransactionsByUserIdOrTransactionId({ userId: user?.usuarioid })
      );
    }
  }, [user?.usuarioid, dispatch]);

  return (
    <>
      <FiltersTransactions
        filters={filters}
        setFilters={setFilters}
        handleGetTransactions={handleGetTransactions}
        credentialId={credentials?.id}
      />
      <Box mt={"24px"} overflow={"auto"}>
        {filters.transactionType === "Portal" ? (
          <TablePortalTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
          />
        ) : filters.transactionType === "Tenui" ? (
          <TableTenuiTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
          />
        ) : (
          <TablePayoneerTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
          />
        )}
      </Box>
      {paginationTransactions?.lastPage > 1 && (
        <Box
          display={"flex"}
          justifyContent={"center"}
          mt={"8px"}
          width={"100%"}
        >
          <Pagination
            count={paginationTransactions?.lastPage}
            page={paginationTransactions?.page}
            onChange={(_, value) => {
              return dispatch(
                getTransactionsByUserIdOrTransactionId({
                  userId: user?.usuarioid,
                  page: value,
                })
              );
            }}
            size="large"
            sx={{ alignSelf: "center", marginTop: "8px" }}
          />
        </Box>
      )}
    </>
  );
};
